import GoogleLogin from 'react-google-login';
import React from 'react';

import AdminForm from './AdminForm';

class AdminPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null
        };
    }

    onSuccessfulLogin = (user) => {
        this.setState({user});
    }

    render() {
        const header = <h6 className="hy-vee-red">{'Supplier Appreciation Administration'}</h6>;

        if (this.state.user) {
            return (
                <main>
                    {header}
                    <AdminForm accessToken={this.state.user.accessToken} />
                </main>
            );
        }

        return (
            <main>
                {header}
                <GoogleLogin
                    clientId={process.env.REACT_APP_CLIENT_ID}
                    onSuccess={this.onSuccessfulLogin}
                    scope="https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/drive"
                />
            </main>
        );
    }
}

export default AdminPage;



// WEBPACK FOOTER //
// ./src/admin/AdminPage.js